import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_2FA } from './types'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'modules/User/Security/Security.module.scss'
import formStyles from 'modules/Forms/common-form.module.scss'

const DoubleFA = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['user'])
  const pathGen = useGeneratePathI18n()
  const { initialized = false, enabled = false } = useSelector(
    (state) => state['user/2fa'],
  )

  useEffect(() => dispatch({ type: GET_2FA }), [])

  return (
    <div>
      <div className={styles['security']}>
        <div className={styles['security__inner']}>
          {initialized ? (
            <>
              <Typography
                variant={'h1'}
                className={styles['security__heading']}
              >
                {t('security.2fa.heading')}
              </Typography>

              <Typography variant={'p7'} className={'margin-bottom-16'}>
                {t('security.2fa.disabled_description')}
              </Typography>

              <Typography variant={'p7'} className={'margin-bottom-32'}>
                {t('security.2fa.summary')}
              </Typography>
              <div
                className={clsx(
                  styles['security__section'],
                  'margin-bottom-40',
                )}
              >
                {enabled ? (
                  <Grid gap={16} alignItems={'center'}>
                    <Col>
                      <Icon
                        className={styles['security__block']}
                        color={'Label-Confirm'}
                        name={'shield-check'}
                        size={'xl'}
                      />
                    </Col>
                    <Col>
                      <Grid gap={0} direction={'column'}>
                        <Col>
                          <Typography variant={'p8'} noMargin>
                            {t('security.2fa.heading')}
                          </Typography>
                        </Col>
                        <Col>
                          <Typography
                            variant={'p8'}
                            color={'Label-Confirm'}
                            noMargin
                          >
                            {t('security.2fa.status.enabled')}
                          </Typography>
                        </Col>
                      </Grid>
                    </Col>
                  </Grid>
                ) : (
                  <Grid gap={16} alignItems={'center'}>
                    <Col>
                      <Icon
                        className={styles['security__block']}
                        color={'Label-Error-Primary'}
                        name={'shield-delete'}
                        size={'xl'}
                      />
                    </Col>
                    <Col>
                      <Grid gap={0} direction={'column'}>
                        <Col>
                          <Typography variant={'p8'} noMargin>
                            {t('security.2fa.heading')}
                          </Typography>
                        </Col>
                        <Col>
                          <Typography
                            variant={'p8'}
                            color={'Label-Error-Primary'}
                            noMargin
                          >
                            {t('security.2fa.status.disabled')}
                          </Typography>
                        </Col>
                      </Grid>
                    </Col>
                  </Grid>
                )}
              </div>

              <div className={formStyles['formControl__action-buttons']}>
                <Button
                  component={Link}
                  to={pathGen(ROUTES.USER_SETTINGS)}
                  variant={'ghost'}
                  grey
                  size="l"
                  color={'Label-Fifth'}
                >
                  {t('common::form_buttons.cancel')}
                </Button>
                <Button
                  fullWidth
                  component={Link}
                  to={pathGen(ROUTES.USER_SECURITY_2FA_SETTING)}
                  bgColor={enabled ? 'Label-Error-Primary' : 'Label-GU-Primary'}
                  size="l"
                  variant="primary"
                >
                  {t(
                    enabled
                      ? 'common::form_buttons.disconnect'
                      : 'common::form_buttons.connect',
                  )}
                </Button>
              </div>
            </>
          ) : (
            <GridSpinner />
          )}
        </div>
      </div>
    </div>
  )
}

export default DoubleFA
